import { Button, FormLabel, Grid, Modal, TextField } from "@mui/material";
import { FunctionComponent } from "react";
import useNav from "../../../../../hooks/useNav";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import { useServicesEditMensagem } from "../services";
import { SelectMinisterioGrupo } from "../../../../../components/selects/ministerioGrupo";


interface EditComponentProps {

}

const EditComponent: FunctionComponent<EditComponentProps> = () => {

  const { goBack } = useNav();

  const { mensagem, alterMensagem, handleUpdate } = useServicesEditMensagem();

  return (<>
    <Modal open onClose={goBack}>
      <ContainerModal>
        <Grid sx={{ borderBottom: '1px solid #ccc', mb: 1, paddingY: 1 }}>
          <p style={{ fontSize: '16px', fontWeight: '600' }}>Editar</p>
        </Grid>

        <SelectMinisterioGrupo
          action={(event) => alterMensagem('ministerioGrupo', event?.target?.value)}
          valor={mensagem?.ministerioGrupo}
        />
        <Grid display={'grid'}>
          <FormLabel>Mensagem</FormLabel>
          <TextField
            onChange={(event) => alterMensagem('mensagem', event?.target?.value?.replace(/(script)|(SCRIPT)|(<html>)/, ''))}
            value={mensagem?.mensagem}
          />
        </Grid>
        <Grid display={'grid'}>
          <FormLabel>Link</FormLabel>
          <TextField
            onChange={(event) => alterMensagem('link', event?.target?.value?.replace(/(script)|(SCRIPT)|(<html>)/, ''))}
            value={mensagem?.link}
          />
        </Grid>

        <Grid display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
          <Button color='error' onClick={goBack}>Cancelar</Button>
          <Button
            variant="contained"
            sx={{ boxShadow: 'none' }}
            onClick={handleUpdate}
          >
            Confirmar
          </Button>
        </Grid>
      </ContainerModal>
    </Modal>
  </>);
}

export default EditComponent;
